module.exports = __webpack_public_path__ + "static/media/disponible-america.0be2b9e9.png";